import styled from 'styled-components';
import { SubH, H3 } from '../../style/typography';
import { MarginContainer } from '../../lib/shared';
import { min } from '../../lib/responsive';

const ColoredRowContainer = styled.div`
  background-color: ${props => props.color};
  margin: 0;
`;
const ColoredRowTextContainer = styled(MarginContainer)`
  display: flex;
  padding: 0.5rem 0;
  @media ${min.tablet} {
    padding: 1.5rem 0;
  }
`;

const ColoredRowDescription = styled(SubH)`
  display: none;
  @media ${min.tabletLg} {
    display: block;
    color: ${props => props.color};
    width: 31rem;
  }
  @media ${min.desktop} {
    padding-left: 1.2rem;
  }
`;

const ColoredRowTime = styled(SubH)`
  color: ${props => props.color};
  width: 6rem;
`;

const ColoredRowTitle = styled(H3)`
  color: ${props => props.color};
  margin: 0;
  font-size: clamp(1.5em, 10vw, 2.5em);
  padding-top: 0.5rem;
  @media ${min.mobile} {
    padding-top: 0.3rem;
    width: 20rem;
  }
  @media ${min.tabletSm} {
    padding-top: 0rem;
    width: 30rem;
  }
  @media ${min.tablet} {
    font-size: 3.1rem;
  }
  @media ${min.desktop} {
    width: 46.5rem;
  }
`;

export {
  ColoredRowContainer,
  ColoredRowTextContainer,
  ColoredRowDescription,
  ColoredRowTime,
  ColoredRowTitle,
};
